export default __webpack_public_path__ + "static/media/actividad-10.e092cc4c.mp3";